// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App shell: sidebar + topbar chrome around the existing pages. Uses tokens from ./tokens/tokens.css
   (imported before this file) so it stays in sync with the Figma "JoPath · Web Platform" handoff. */

.shell {
  display: flex;
  min-height: 100vh;
  background: var(--background);
}

/* ---------- Sidebar ---------- */

.shell__sidebar {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: var(--sidebar-width);
  background: var(--sidebar);
  border-inline-end: 1px solid var(--sidebar-border);
  transition: width var(--duration-base) var(--ease-standard);
  overflow: hidden;
}

.shell__sidebar.is-collapsed {
  width: var(--sidebar-width-icon);
}

.shell__logo {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 1rem;
  color: var(--sidebar-foreground);
  text-decoration: none;
  flex-shrink: 0;
}

.shell__logo .brand__mark {
  width: 34px;
  height: 34px;
  background: var(--sidebar-primary);
  color: var(--sidebar-primary-foreground);
}

.shell__logo-text {
  font-size: var(--text-h3);
  font-weight: 700;
  color: var(--foreground);
  white-space: nowrap;
}

.is-collapsed .shell__logo-text {
  display: none;
}

.shell__nav {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.25rem 0.75rem 1rem;
}

.shell__nav ul {
  list-style: none;
  margin: 0 0 0.75rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.shell__nav-heading {
  margin: 0.75rem 0.6rem 0.3rem;
  font-size: var(--text-overline);
  font-weight: var(--text-overline--font-weight);
  letter-spacing: 0.06em;
  color: var(--text-subtle);
  text-transform: uppercase;
  white-space: nowrap;
}

.is-collapsed .shell__nav-heading {
  display: none;
}

.shell__nav-item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.6rem;
  border-radius: var(--radius-md);
  color: var(--sidebar-foreground);
  text-decoration: none;
  font-size: var(--text-body);
  white-space: nowrap;
  cursor: pointer;
}

a.shell__nav-item:hover {
  background: var(--sidebar-accent);
  color: var(--sidebar-accent-foreground);
}

.shell__nav-item.is-active {
  background: var(--sidebar-accent);
  color: var(--sidebar-accent-foreground);
  font-weight: 600;
}

.shell__nav-item.is-disabled {
  color: var(--text-disabled);
  opacity: var(--opacity-disabled);
  cursor: not-allowed;
}

.shell__nav-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.is-collapsed .shell__nav-label,
.is-collapsed .shell__nav-soon,
.is-collapsed .shell__nav-count,
.is-collapsed .shell__nav-subitems {
  display: none;
}

.shell__nav-soon {
  font-size: var(--text-caption);
  color: var(--text-disabled);
  white-space: nowrap;
}

.shell__nav-count {
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: var(--radius-full, 999px);
  background: var(--danger, #d92d20);
  color: var(--danger-foreground, #fff);
  font-size: var(--text-caption);
  font-weight: 600;
  line-height: 19px;
  text-align: center;
  white-space: nowrap;
}

.shell__nav-subitems {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  margin: 0.15rem 0 0.25rem;
  padding-inline-end: 0.6rem;
  border-inline-end: 2px solid var(--sidebar-border);
  margin-inline-end: 1.1rem;
}

.shell__nav-subitem {
  padding: 0.4rem 0.6rem;
  margin-inline-end: -2px;
  border-inline-end: 2px solid transparent;
  color: var(--sidebar-foreground);
  text-decoration: none;
  font-size: var(--text-body-sm);
  border-radius: var(--radius-sm);
}

.shell__nav-subitem:hover {
  background: var(--sidebar-accent);
}

.shell__nav-subitem.is-active {
  border-inline-end-color: var(--sidebar-primary);
  color: var(--sidebar-primary);
  font-weight: 600;
}

.shell__user {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.85rem 1rem;
  border-top: 1px solid var(--sidebar-border);
  flex-shrink: 0;
  color: inherit;
  text-decoration: none;
}

a.shell__user:hover {
  background: var(--sidebar-accent);
}

.shell__avatar {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  background: var(--primary-subtle);
  color: var(--primary-text);
  font-weight: 700;
}

.shell__user-info {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  overflow: hidden;
}

.shell__user-info strong {
  font-size: var(--text-body-sm);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.shell__user-info small {
  color: var(--text-subtle);
  font-size: var(--text-caption);
}

.is-collapsed .shell__user-info {
  display: none;
}

/* ---------- Topbar ---------- */

.shell__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.offline-banner {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.25rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--warning-subtle-foreground);
  background: var(--warning-subtle);
  border-bottom: 1px solid var(--warning-border);
}

.shell__topbar {
  position: sticky;
  top: 0;
  z-index: var(--z-header);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: var(--header-height);
  padding: 0 clamp(1rem, 2vw, 1.5rem);
  background: var(--card);
  border-bottom: 1px solid var(--border);
}

.shell__topbar-start {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex: 1 1;
}

.shell__topbar-start .crumbs {
  overflow: hidden;
}

.shell__topbar-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.shell__search {
  width: 100%;
  max-width: 360px;
  min-height: 36px;
  background: var(--surface-sunken);
  color: var(--text-disabled);
  cursor: not-allowed;
}

.shell__topbar-end {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
}

.shell__lang {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  background: var(--muted);
  border-radius: var(--radius-md);
}

.shell__lang-btn {
  min-width: 34px;
  min-height: 34px;
  padding: 0 0.45rem;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--muted-foreground);
  font-weight: 600;
  font-size: var(--text-body-sm);
  cursor: pointer;
}

.shell__lang-btn.is-active {
  background: var(--card);
  color: var(--foreground);
  box-shadow: var(--shadow-color-soft) 0 1px 2px;
}

.shell__project-switch {
  width: auto;
  min-height: 36px;
  max-width: 220px;
}

.crumbs__entry {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.crumbs__entry a {
  color: var(--text-subtle);
  text-decoration: none;
}

.crumbs__entry a:hover {
  color: var(--primary-text);
  text-decoration: underline;
}

/* ---------- Responsive ---------- */

@media (max-width: 1024px) {
  .shell__topbar-center {
    display: none;
  }
}

@media (max-width: 768px) {
  .shell {
    --shell-bar-height: 6.75rem;
  }

  .shell__topbar {
    z-index: calc(var(--z-overlay) + 1);
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto auto;
    grid-template-areas:
      'toggle title alerts leave'
      'project project language theme';
    align-items: center;
    height: auto;
    gap: 0.45rem 0.35rem;
    padding: 0.5rem 0.75rem;
  }

  .shell__topbar-start,
  .shell__topbar-end {
    display: contents;
  }

  .shell__topbar #sidebar-toggle {
    grid-area: toggle;
  }

  .shell__topbar .crumbs {
    grid-area: title;
    flex-wrap: nowrap;
    min-width: 0;
    overflow: hidden;
    font-weight: 600;
  }

  .shell__topbar .crumbs__entry:not(:last-child) {
    display: none;
  }

  .shell__topbar .crumbs__entry:last-child {
    min-width: 0;
  }

  .shell__topbar .crumbs__entry:last-child .icon {
    display: none;
  }

  .shell__topbar .crumbs__entry span,
  .shell__topbar .crumbs__entry a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .shell__topbar .bell {
    grid-area: alerts;
    justify-self: end;
    width: auto;
  }

  .shell__topbar .shell__signout {
    grid-area: leave;
  }

  .shell__topbar .shell__project-switch {
    grid-area: project;
    width: 100%;
    max-width: none;
    min-width: 0;
  }

  .shell__topbar .shell__lang {
    grid-area: language;
    justify-self: end;
  }

  .shell__topbar .shell__theme {
    grid-area: theme;
  }

  .shell__topbar .icon-button {
    flex-shrink: 0;
  }

  .shell__sidebar,
  .shell__sidebar.is-collapsed {
    position: fixed;
    inset-block: var(--shell-bar-height, var(--header-height)) 0;
    inset-inline-start: 0;
    z-index: var(--z-overlay);
    width: min(86vw, var(--sidebar-width));
    transform: translateX(-100%);
    visibility: hidden;
    pointer-events: none;
    transition:
      transform var(--duration-base) var(--ease-standard),
      visibility 0s linear var(--duration-base);
  }

  [dir='rtl'] .shell__sidebar,
  [dir='rtl'] .shell__sidebar.is-collapsed {
    transform: translateX(100%);
  }

  .shell__sidebar.is-drawer-open,
  [dir='rtl'] .shell__sidebar.is-drawer-open {
    transform: translateX(0);
    visibility: visible;
    pointer-events: auto;
    box-shadow: 0 12px 40px var(--shadow-color-strong);
    transition:
      transform var(--duration-base) var(--ease-standard),
      visibility 0s linear 0s;
  }

  .shell__backdrop {
    position: fixed;
    inset: 0;
    z-index: calc(var(--z-overlay) - 1);
    margin: 0;
    padding: 0;
    border: 0;
    background: var(--overlay);
    cursor: pointer;
  }

  .shell__main {
    margin-inline-start: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/app-shell.css"],"names":[],"mappings":"AAAA;oGACoG;;AAEpG;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,2BAA2B;EAC3B,0BAA0B;EAC1B,kDAAkD;EAClD,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,8CAA8C;EAC9C,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,kCAAkC;EAClC,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,2CAA2C;EAC3C,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;;AAEjC;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,qCAAqC;;AAErC;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,mCAAmC;IACnC,aAAa;IACb,oDAAoD;IACpD;;sCAEkC;IAClC,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,4DAA4D;IAC5D,qBAAqB;IACrB,yBAAyB;IACzB,sCAAsC;IACtC,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB;;+CAE2C;EAC7C;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;IACxB,mBAAmB;IACnB,oBAAoB;IACpB,kDAAkD;IAClD;;6BAEyB;EAC3B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,mCAAmC;IACnC,SAAS;IACT,UAAU;IACV,SAAS;IACT,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* App shell: sidebar + topbar chrome around the existing pages. Uses tokens from ./tokens/tokens.css\r\n   (imported before this file) so it stays in sync with the Figma \"JoPath · Web Platform\" handoff. */\r\n\r\n.shell {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  background: var(--background);\r\n}\r\n\r\n/* ---------- Sidebar ---------- */\r\n\r\n.shell__sidebar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-shrink: 0;\r\n  width: var(--sidebar-width);\r\n  background: var(--sidebar);\r\n  border-inline-end: 1px solid var(--sidebar-border);\r\n  transition: width var(--duration-base) var(--ease-standard);\r\n  overflow: hidden;\r\n}\r\n\r\n.shell__sidebar.is-collapsed {\r\n  width: var(--sidebar-width-icon);\r\n}\r\n\r\n.shell__logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  padding: 1rem;\r\n  color: var(--sidebar-foreground);\r\n  text-decoration: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.shell__logo .brand__mark {\r\n  width: 34px;\r\n  height: 34px;\r\n  background: var(--sidebar-primary);\r\n  color: var(--sidebar-primary-foreground);\r\n}\r\n\r\n.shell__logo-text {\r\n  font-size: var(--text-h3);\r\n  font-weight: 700;\r\n  color: var(--foreground);\r\n  white-space: nowrap;\r\n}\r\n\r\n.is-collapsed .shell__logo-text {\r\n  display: none;\r\n}\r\n\r\n.shell__nav {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 0.25rem 0.75rem 1rem;\r\n}\r\n\r\n.shell__nav ul {\r\n  list-style: none;\r\n  margin: 0 0 0.75rem;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.shell__nav-heading {\r\n  margin: 0.75rem 0.6rem 0.3rem;\r\n  font-size: var(--text-overline);\r\n  font-weight: var(--text-overline--font-weight);\r\n  letter-spacing: 0.06em;\r\n  color: var(--text-subtle);\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n.is-collapsed .shell__nav-heading {\r\n  display: none;\r\n}\r\n\r\n.shell__nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  padding: 0.55rem 0.6rem;\r\n  border-radius: var(--radius-md);\r\n  color: var(--sidebar-foreground);\r\n  text-decoration: none;\r\n  font-size: var(--text-body);\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\na.shell__nav-item:hover {\r\n  background: var(--sidebar-accent);\r\n  color: var(--sidebar-accent-foreground);\r\n}\r\n\r\n.shell__nav-item.is-active {\r\n  background: var(--sidebar-accent);\r\n  color: var(--sidebar-accent-foreground);\r\n  font-weight: 600;\r\n}\r\n\r\n.shell__nav-item.is-disabled {\r\n  color: var(--text-disabled);\r\n  opacity: var(--opacity-disabled);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.shell__nav-label {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.is-collapsed .shell__nav-label,\r\n.is-collapsed .shell__nav-soon,\r\n.is-collapsed .shell__nav-count,\r\n.is-collapsed .shell__nav-subitems {\r\n  display: none;\r\n}\r\n\r\n.shell__nav-soon {\r\n  font-size: var(--text-caption);\r\n  color: var(--text-disabled);\r\n  white-space: nowrap;\r\n}\r\n\r\n.shell__nav-count {\r\n  min-width: 19px;\r\n  height: 19px;\r\n  padding: 0 5px;\r\n  border-radius: var(--radius-full, 999px);\r\n  background: var(--danger, #d92d20);\r\n  color: var(--danger-foreground, #fff);\r\n  font-size: var(--text-caption);\r\n  font-weight: 600;\r\n  line-height: 19px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.shell__nav-subitems {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.1rem;\r\n  margin: 0.15rem 0 0.25rem;\r\n  padding-inline-end: 0.6rem;\r\n  border-inline-end: 2px solid var(--sidebar-border);\r\n  margin-inline-end: 1.1rem;\r\n}\r\n\r\n.shell__nav-subitem {\r\n  padding: 0.4rem 0.6rem;\r\n  margin-inline-end: -2px;\r\n  border-inline-end: 2px solid transparent;\r\n  color: var(--sidebar-foreground);\r\n  text-decoration: none;\r\n  font-size: var(--text-body-sm);\r\n  border-radius: var(--radius-sm);\r\n}\r\n\r\n.shell__nav-subitem:hover {\r\n  background: var(--sidebar-accent);\r\n}\r\n\r\n.shell__nav-subitem.is-active {\r\n  border-inline-end-color: var(--sidebar-primary);\r\n  color: var(--sidebar-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.shell__user {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 0.85rem 1rem;\r\n  border-top: 1px solid var(--sidebar-border);\r\n  flex-shrink: 0;\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\na.shell__user:hover {\r\n  background: var(--sidebar-accent);\r\n}\r\n\r\n.shell__avatar {\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: var(--radius-full);\r\n  background: var(--primary-subtle);\r\n  color: var(--primary-text);\r\n  font-weight: 700;\r\n}\r\n\r\n.shell__user-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.3;\r\n  overflow: hidden;\r\n}\r\n\r\n.shell__user-info strong {\r\n  font-size: var(--text-body-sm);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.shell__user-info small {\r\n  color: var(--text-subtle);\r\n  font-size: var(--text-caption);\r\n}\r\n\r\n.is-collapsed .shell__user-info {\r\n  display: none;\r\n}\r\n\r\n/* ---------- Topbar ---------- */\r\n\r\n.shell__main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.offline-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1.25rem;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--warning-subtle-foreground);\r\n  background: var(--warning-subtle);\r\n  border-bottom: 1px solid var(--warning-border);\r\n}\r\n\r\n.shell__topbar {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: var(--z-header);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  height: var(--header-height);\r\n  padding: 0 clamp(1rem, 2vw, 1.5rem);\r\n  background: var(--card);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.shell__topbar-start {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.shell__topbar-start .crumbs {\r\n  overflow: hidden;\r\n}\r\n\r\n.shell__topbar-center {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.shell__search {\r\n  width: 100%;\r\n  max-width: 360px;\r\n  min-height: 36px;\r\n  background: var(--surface-sunken);\r\n  color: var(--text-disabled);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.shell__topbar-end {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.shell__lang {\r\n  display: inline-flex;\r\n  gap: 2px;\r\n  padding: 2px;\r\n  background: var(--muted);\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n.shell__lang-btn {\r\n  min-width: 34px;\r\n  min-height: 34px;\r\n  padding: 0 0.45rem;\r\n  border: 0;\r\n  border-radius: var(--radius-sm);\r\n  background: transparent;\r\n  color: var(--muted-foreground);\r\n  font-weight: 600;\r\n  font-size: var(--text-body-sm);\r\n  cursor: pointer;\r\n}\r\n\r\n.shell__lang-btn.is-active {\r\n  background: var(--card);\r\n  color: var(--foreground);\r\n  box-shadow: var(--shadow-color-soft) 0 1px 2px;\r\n}\r\n\r\n.shell__project-switch {\r\n  width: auto;\r\n  min-height: 36px;\r\n  max-width: 220px;\r\n}\r\n\r\n.crumbs__entry {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.crumbs__entry a {\r\n  color: var(--text-subtle);\r\n  text-decoration: none;\r\n}\r\n\r\n.crumbs__entry a:hover {\r\n  color: var(--primary-text);\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ---------- Responsive ---------- */\r\n\r\n@media (max-width: 1024px) {\r\n  .shell__topbar-center {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .shell {\r\n    --shell-bar-height: 6.75rem;\r\n  }\r\n\r\n  .shell__topbar {\r\n    z-index: calc(var(--z-overlay) + 1);\r\n    display: grid;\r\n    grid-template-columns: auto minmax(0, 1fr) auto auto;\r\n    grid-template-areas:\r\n      'toggle title alerts leave'\r\n      'project project language theme';\r\n    align-items: center;\r\n    height: auto;\r\n    gap: 0.45rem 0.35rem;\r\n    padding: 0.5rem 0.75rem;\r\n  }\r\n\r\n  .shell__topbar-start,\r\n  .shell__topbar-end {\r\n    display: contents;\r\n  }\r\n\r\n  .shell__topbar #sidebar-toggle {\r\n    grid-area: toggle;\r\n  }\r\n\r\n  .shell__topbar .crumbs {\r\n    grid-area: title;\r\n    flex-wrap: nowrap;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .shell__topbar .crumbs__entry:not(:last-child) {\r\n    display: none;\r\n  }\r\n\r\n  .shell__topbar .crumbs__entry:last-child {\r\n    min-width: 0;\r\n  }\r\n\r\n  .shell__topbar .crumbs__entry:last-child .icon {\r\n    display: none;\r\n  }\r\n\r\n  .shell__topbar .crumbs__entry span,\r\n  .shell__topbar .crumbs__entry a {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .shell__topbar .bell {\r\n    grid-area: alerts;\r\n    justify-self: end;\r\n    width: auto;\r\n  }\r\n\r\n  .shell__topbar .shell__signout {\r\n    grid-area: leave;\r\n  }\r\n\r\n  .shell__topbar .shell__project-switch {\r\n    grid-area: project;\r\n    width: 100%;\r\n    max-width: none;\r\n    min-width: 0;\r\n  }\r\n\r\n  .shell__topbar .shell__lang {\r\n    grid-area: language;\r\n    justify-self: end;\r\n  }\r\n\r\n  .shell__topbar .shell__theme {\r\n    grid-area: theme;\r\n  }\r\n\r\n  .shell__topbar .icon-button {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .shell__sidebar,\r\n  .shell__sidebar.is-collapsed {\r\n    position: fixed;\r\n    inset-block: var(--shell-bar-height, var(--header-height)) 0;\r\n    inset-inline-start: 0;\r\n    z-index: var(--z-overlay);\r\n    width: min(86vw, var(--sidebar-width));\r\n    transform: translateX(-100%);\r\n    visibility: hidden;\r\n    pointer-events: none;\r\n    transition:\r\n      transform var(--duration-base) var(--ease-standard),\r\n      visibility 0s linear var(--duration-base);\r\n  }\r\n\r\n  [dir='rtl'] .shell__sidebar,\r\n  [dir='rtl'] .shell__sidebar.is-collapsed {\r\n    transform: translateX(100%);\r\n  }\r\n\r\n  .shell__sidebar.is-drawer-open,\r\n  [dir='rtl'] .shell__sidebar.is-drawer-open {\r\n    transform: translateX(0);\r\n    visibility: visible;\r\n    pointer-events: auto;\r\n    box-shadow: 0 12px 40px var(--shadow-color-strong);\r\n    transition:\r\n      transform var(--duration-base) var(--ease-standard),\r\n      visibility 0s linear 0s;\r\n  }\r\n\r\n  .shell__backdrop {\r\n    position: fixed;\r\n    inset: 0;\r\n    z-index: calc(var(--z-overlay) - 1);\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    background: var(--overlay);\r\n    cursor: pointer;\r\n  }\r\n\r\n  .shell__main {\r\n    margin-inline-start: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
